import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {User} from 'src/app/core/service/core-models';
import {CoreService} from 'src/app/core/service/core.service';
import {UserService} from 'src/app/shared/services';
import {FeatureConfigurationsService, SageExport} from 'src/app/shared/services/feature-configurations.service';

@Component({
  selector: 'app-month-end',
  templateUrl: './month-end.component.html',
  styleUrls: ['./month-end.component.scss'],
})
export class MonthEndComponent implements OnInit {
  @Input() statement;
  @Output() sageToggleSet = new EventEmitter<boolean>();
  sageToggle = null;
  isBusy = false;
  busyText = '';
  error = false;
  posted = false;
  userEmail = '';
  sqlMonthEndId = null;
  private SiteId = sessionStorage.getItem('SITEID') || '';
  private CustomerId = sessionStorage.getItem('CUSTOMERID') || '';

  constructor(
    private featureConfigurationsService: FeatureConfigurationsService,
    public coreService: CoreService,
    public userService: UserService
  ) {}

  ngOnInit(): void {
    this.userService.getUser().subscribe(
      (user: User) => {
        this.userEmail = user.email;
      },
      error => {
        console.error(error);
        this.coreService.displayError('There was error when retrieving current user information');
      }
    );
    this.getToggleInformation();
  }

  confirmPopup() {
    const selectedMonth = new Date(this.statement.statementYear, this.statement.statementMonth + 1, 0)
      .toLocaleString('en-us', {month: 'short', year: 'numeric'})
      .toString();
    this.coreService.confirmAction(
      ``,
      this.sendRequest,
      `Export this month?`,
      `Are you sure you want to send transactional data for ${selectedMonth} to your GL? This cannot be undone.`,
      `Send`
    );
  }

  confirmSuccess() {
    const selectedMonth = new Date(this.statement.statementYear, this.statement.statementMonth + 1, 0)
      .toLocaleString('en-us', {month: 'short', year: 'numeric'})
      .toString();
    this.coreService.displaySuccess(``, `Success`, `Successfully exported transactions for ${selectedMonth}`, `Ok`);
  }

  sendRequest = () => {
    this.isBusy = true;
    this.busyText = 'Sending Sage Export, please wait.';
    const endOfMonth = new Date(this.statement.statementYear, this.statement.statementMonth + 1, 0).getDate();
    try {
      this.featureConfigurationsService.querySageData().subscribe(result => {
        if (result && result.length > 0) {
          const command: SageExport = {
            sageClientDataId: result[0].id,
            siteId: this.SiteId,
            customerId: this.CustomerId,
            periodStart: `${this.statement.statementMonth + 1}/1/${this.statement.statementYear}`,
            periodEnd: `${this.statement.statementMonth + 1}/${endOfMonth}/${this.statement.statementYear}`,
          };
          this.featureConfigurationsService.sendSageExport(command).subscribe(
            () => {
              this.posted = true;
              this.createSageMonthEnd();
            },
            error => {
              this.isBusy = false;
              this.coreService.displayError(`Error sending Sage Export: ${error.error.message}`);
            }
          );
        } else {
          this.isBusy = false;
          this.coreService.displayError('Error: Sage Information not found');
        }
      });
    } catch (error) {
      this.isBusy = false;
    }
  };

  createSageMonthEnd = () => {
    const monthEndCommand = {
      month: this.statement.statementMonth,
      year: this.statement.statementYear,
      exported: true,
      exportedOn: new Date(),
      exportedBy: this.userEmail,
      customerId: this.CustomerId,
      siteId: this.SiteId,
      modifiedBy: null,
      createdBy: null,
    };
    if (this.sqlMonthEndId) {
      monthEndCommand.modifiedBy = this.userEmail;
      delete monthEndCommand.createdBy;
      this.featureConfigurationsService.updateSageMonthEndExport(monthEndCommand).subscribe(
        result => {
          this.isBusy = false;
          this.confirmSuccess();
        },
        error => {
          this.isBusy = false;
          this.coreService.displayError(
            `Transactions successfully exported but an Error occured while recording Export status: ${error.error}`
          );
        }
      );
    } else {
      monthEndCommand.createdBy = this.userEmail;
      delete monthEndCommand.modifiedBy;
      this.featureConfigurationsService.createSageMonthEndExport(monthEndCommand).subscribe(
        result => {
          this.isBusy = false;
          this.confirmSuccess();
        },
        error => {
          this.isBusy = false;
          this.coreService.displayError(`Error sending recording Sage status: ${error.error}`);
        }
      );
    }
  };

  getToggleInformation() {
    if (this.sageToggle == null) {
      this.featureConfigurationsService.getFeatureConfigurations().subscribe(result => {
        this.featureConfigurationsService.getConfigurationsValuesBySiteId(this.SiteId).subscribe(configValues => {
          const featureConfig = result[0].find(fc => fc.subdomain == 'sageIntacct');
          if (featureConfig) {
            const selectedValue = configValues[0].find(config => config.featureConfigurationId === featureConfig.id);
            if (selectedValue && featureConfig.subdomain == 'sageIntacct' && selectedValue.booleanValue == true) {
              this.sageToggle = true;
              this.fetchMonthEnd();
              this.sageToggleSet.emit(true);
            } else {
              this.sageToggle = false;
            }
          }
        });
      });
    }
  }

  fetchMonthEnd() {
    this.featureConfigurationsService.getSageMonthEnd(this.statement.statementMonth, this.statement.statementYear).subscribe(monthEnd => {
      if (monthEnd && monthEnd.exported) {
        this.posted = true;
      }
      if (monthEnd && !monthEnd.exported) {
        this.sqlMonthEndId = monthEnd.id;
      }
    });
  }
}
